<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut')
                }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('meetingS.yhquery.title') }}</div>
                <div class="mainBody">
                    <table width="100%" border="0" cellspacing="4" cellpadding="0">
                        <tbody>
                            <tr>
                                <td :width="$i18n.locale == 'jp' ? '20%' : '18%'">
                                    &nbsp;{{ $t('meetingS.yhquery.thead.td1') }}&nbsp;</td>
                                <td :width="$i18n.locale == 'jp' ? '60%' : '67%'">
                                    &nbsp;{{ $t('meetingS.yhquery.thead.td2') }}&nbsp;</td>
                                <td :width="$i18n.locale == 'jp' ? '20%' : '15%'"
                                    :style="{ 'line-height': $i18n.locale == 'jp' ? '.3rem' : '' }">
                                    &nbsp;{{ $t('meetingS.yhquery.thead.td3') }}&nbsp;</td>
                            </tr>
                            <tr>
                                <td>{{ name }}</td>
                                <td :style="{ 'line-height': $i18n.locale == 'jp' ? '.3rem' : '' }">
                                    18:30-20:30　{{ table_number_address == '广东厅' ? $t('meetingS.theme.meet_place') :
                                        $t('meetingS.theme.g30_place') }}</td>
                                <td>{{ table_number_text }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="search_main">
                        <div>
                            <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/user.png?v=0223" alt="" class="imgUser">
                            <span style="text-align: left;color:#fff;width: 100%;flex:1;text-indent: 1em;">{{ $t('meetingS.yhquery.guest') }}</span>
                            <!-- <input type="text" name="" :placeholder="" id="" disabled=""> -->
                            <span @click="getDeskmate"><img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/search.png?v=0223" alt="">{{ $t('meetingS.theme.btn') }}</span>
                        </div>
                    </div>
                    <div id="zhjb1" style="font-size:0.25rem;" v-show='is_show'>{{ $t('meetingS.yhquery.results') }}
                    </div>
                    <table id="zhjb2" width="100%" border="0" cellspacing="0" cellpadding="0"
                        style="border-collapse: collapse;" v-show='is_show'>
                        <tbody>
                            <tr>
                                <td :width="$i18n.locale == 'jp' ? '20%' : '18%'">
                                    &nbsp;{{ $t('meetingS.yhquery.thead.td1') }}&nbsp;</td>
                                <td :width="$i18n.locale == 'jp' ? '60%' : '67%'">
                                    &nbsp;{{ $t('meetingS.yhquery.thead.td2') }}&nbsp;</td>
                                <td :width="$i18n.locale == 'jp' ? '20%' : '15%'"
                                    :style="{ 'line-height': $i18n.locale == 'jp' ? '.3rem' : '' }">
                                    &nbsp;{{ $t('meetingS.yhquery.thead.td3') }}&nbsp;</td>
                            </tr>
                            <tr v-for="(item, index) in mate" :key="index">
                                <td>{{ item.u_name }}</td>
                                <td :style="{ 'line-height': $i18n.locale == 'jp' ? '.3rem' : '' }">
                                    18:30-20:30　{{ item.u_table_num_area == '' ? '' : item.u_table_num_area == '广东厅' ?
                                        $t('meetingS.theme.meet_place') :
                                        $t('meetingS.theme.g30_place') }}</td>
                                <td>{{ item.u_table_num }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="search_main">
                        <div>
                            <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/name.png" alt="" class="imgName"><input type="text" v-model="query_name" :placeholder="$t('meetingS.yhquery.query_tips')">
                            <span @click="query_submit"><img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/search.png?v=0223" alt="">{{ $t('meetingS.theme.btn') }}</span>
                        </div>
                    </div>
                    <div id="zhjb1" style="font-size:0.25rem;" v-show='is_guest'>{{ $t('meetingS.yhquery.results') }}
                    </div>
                    <table id="zhjb2" width="100%" border="0" cellspacing="0" cellpadding="0"
                        style="border-collapse: collapse;" v-show='is_guest'>
                        <tbody>
                            <tr>
                                <td :width="$i18n.locale == 'jp' ? '20%' : '18%'">
                                    &nbsp;{{ $t('meetingS.yhquery.thead.td1') }}&nbsp;</td>
                                <td :width="$i18n.locale == 'jp' ? '60%' : '67%'">
                                    &nbsp;{{ $t('meetingS.yhquery.thead.td2') }}&nbsp;</td>
                                <td :width="$i18n.locale == 'jp' ? '20%' : '15%'"
                                    :style="{ 'line-height': $i18n.locale == 'jp' ? '.3rem' : '' }">
                                    &nbsp;{{ $t('meetingS.yhquery.thead.td3') }}&nbsp;</td>
                            </tr>
                            <tr v-for="(item, index) in guest" :key="index">
                                <td>{{ item.u_name }}</td>
                                <td :style="{ 'line-height': $i18n.locale == 'jp' ? '.3rem' : '' }">
                                    18:30-20:30　{{ item.u_table_number_address == '广东厅' ?
                                        $t('meetingS.theme.meet_place')
                                        : item.u_table_number_address == '广东厅' ? $t('meetingS.theme.g30_place') : '' }}</td>
                                <td>{{ item.u_table_num }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div style="height: .3rem;"></div>
                    <img class='preview-img' width="100%" widths="1500" heights="2363"
                        links="https://oss.eventnet.cn/H5/Nissan_meeting/2024/map11.jpg?v=1220"
                        src='https://oss.eventnet.cn/H5/Nissan_meeting/2024/map11.jpg?v=1220' @click="bigImg">
                    <!-- <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/map11.jpg?v=1220" alt="" class="map"> -->
                    <p class="center">{{ $t('meetingS.theme.meet_place') }}</p>
                    <!-- <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2023/map111.png?v=1214" alt="" class="map">
                    <p class="center">{{ $t('meetingS.theme.g30_place') }}</p> -->
                </div>
            </div>
        </div>
        <div class="back" @click="path('meetingS')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
        <Photo class="img_big" :items="items" v-if="bigImg_show" @show="close" />
    </div>
</template>
<script>
import menus from "../../components/menu.vue"
import Photo from '../../components/PhotoSwipe';
export default {
    components: {
        menus,
        Photo
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            is_show: false,
            is_guest: false,
            query_name: "",
            toastText: '',
            toastShow: false,
            table_number_text: "",
            table_number_address: "",
            name: "",
            mate: [],
            click: true,
            guest: [],
            items: [{
                src: '',
                w: 0,
                h: 0,
            },],
            bigImg_show: false,
        }
    },
    created() {
        let that = this, data = new FormData();
        that.name = that.$route.query.name;
        if (that.name == "me") {
            that.is_me = true;
            data.append('uuid', localStorage.getItem('nissan2023_meeting_uuid'))
            that.axios.post("banquetQuery", data).then(res => {
                if (res.data.code == 200) {
                    that.name = res.data.name;
                    that.table_number_text = res.data.tableNum;
                    that.table_number_address = res.data.address;

                }
            }).catch(err => {
                console.error(err);
            })
        }
        //_hmt.push(['_trackPageview', '/meetingS/yhquery']);
    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        bigImg(el) {
            this.items[0].w = el.target.getAttribute('widths');
            this.items[0].h = el.target.getAttribute('heights');
            this.items[0].src = el.target.getAttribute('links');
            this.bigImg_show = true;
        },
        close(e) {
            this.bigImg_show = e;
        },
        getDeskmate() {
            let that = this, data = new FormData();
            if (that.click) {
                that.click = false;
                data.append('uuid', localStorage.getItem('nissan2023_meeting_uuid'))
                that.axios.post("banquetQuery", data).then(res => {
                    if (res.data.code == 200) {
                        that.mate = res.data.data;
                        that.click = that.is_show = true;
                    }
                }).catch(err => {
                    console.error(err);
                })
            }

        },
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.clear();
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        },
        query_submit() {
            let that = this, data = new FormData();
            if (that.click) {
                that.click = false;
                if (that.query_name == '') {
                    that.toast(that.$t('meetingS.theme.query_tips1'))
                } else {
                    data.append('uuid', localStorage.getItem('nissan2023_meeting_uuid'))
                    data.append("search", that.query_name)
                    that.axios.post("banquetQuery", data).then(res => {
                        if (res.data.code == 200) {
                            if (res.data.data2 == '') {
                                that.toast(that.$t('meetingS.theme.query_tips_none'))
                            } else {
                                that.guest = res.data.data2;
                                that.is_guest = true
                            }
                            that.click = that.is_show = true;
                            that.is_show = false

                        } else {
                            that.click = true;
                            that.toast(that.$t('meetingS.theme.query_tips_none'))
                        }
                    }).catch(err => {
                        console.error(err);
                    })
                }
            }
        },
        toast(str) {
            let that = this
            that.toastText = str
            that.toastShow = true
            setTimeout(function () {
                that.toastShow = false;
                that.click = true;
            }, 1500)
        },
    }
}
</script>
<style scoped>
.container {
    padding-bottom: .5rem;
}

.query_main tr:last-child td {
    border: 1px solid #fefefe;
    font-size: .26rem !important;
    line-height: .6rem;
    text-align: center;
    color: #fff !important;
    background-color: #f2f2f2 !important
}

.mini {
    font-size: .2rem !important;
    line-height: .25rem !important;
    display: -webkit-flex;
    align-items: center;
    text-align: center;
}

.toast {
    padding: 0 .3rem;
}

.center {
    padding-bottom: .5rem;
}

.map {
    width: 100%;
    display: block;

}



.search_main {
    margin-top: .58rem;
    color: #fff;
}

.search_main>div {
    display: -webkit-flex;
    align-items: center;
    justify-content: space-between;
    font-size: .24rem;
    width: 100%;
    height: .84rem;
    background: url(https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/input_bg.png) no-repeat;
    background-size: 100% 100%;
    color: #fff;
    margin-bottom: .33rem;
    padding: 0 .25rem;
}

.search_main>div input {
    height: 100%;
    background: none;
    flex: 1;
    color: #fff;
    text-indent: 1em;
}

input::-webkit-input-placeholder {
    color: #fff;
    font-size: .26rem;
}

.search_main>div span {
    display: -webkit-flex;
    height: 100%;
    align-items: center;
    color: #0b8383;
}

.search_main>div span img {
    margin-right: .1rem;
    width: .4rem;
}

.search_main .imgUser {
    width: .29rem;
    height: .34rem;
    margin-left: .05rem;
    margin-right: .05rem;
}

.search_main .imgName {
    width: .40rem;
    height: .32rem;
}


table {
    width: 100%;
    width: 6;
    font-size: .3rem;
}

table tr>td {
    font-size: .26rem;
    line-height: .5rem;
    text-align: center;
    color: #0b8383;
}

table tr {
    background: rgba(198, 253, 252, .7);
}

table tr:first-child {
    background: #17aba2;
    color: #fff;
}

table tr:first-child>td {
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/meetingS/yhquery.vue